const func = $target => {
	window.loader.key('rateyo', function() {
		$target.rateYo({
			starWidth: '30px',
			spacing: '-1px',
			normalFill: '#dee2e6',
			ratedFill: '#F2DC31',
			fullStar: true,
			starSvg: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><use xlink:href="#reviewStar"></use></svg>',
			onSet: function(rating, rateYoInstance) {
				$('[name="' + $target.data('target') + '"]').val(rating);
			}
		});
	});
};

export default func;
